import React, { useState, useEffect } from 'react';
import './header.css';
import logo from '../../images/logo.png';
import nav__links from '../../data/menu.json';
import ThemeToggle from '../ThemeToggle/ThemeToggle';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down and past 100px
        setIsHeaderVisible(false);
        setIsMenuOpen(false); // Close mobile menu when hiding header
      } else {
        // Scrolling up
        setIsHeaderVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header
      className={`header ${
        isHeaderVisible ? 'header-visible' : 'header-hidden'
      }`}
    >
      <div className='container'>
        <div className='nav__wrapper'>
          <div className='logo'>
            <img
              src={logo}
              width='150px'
              height='60px'
              alt='Ergue Escritorio Logo'
            />
          </div>

          {/* Mobile menu toggle */}
          <div className='mobile-menu-toggle' onClick={toggleMenu}>
            <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>

          {/* Navigation */}
          <div className={`navigation ${isMenuOpen ? 'mobile-menu-open' : ''}`}>
            <ul className='menu'>
              {nav__links.map((item, index) => (
                <li key={index} className='menu_item'>
                  <a
                    href={item.path}
                    className='menu__link'
                    onClick={closeMenu}
                  >
                    {item.display}
                  </a>
                </li>
              ))}
              <li className='menu_item'>
                <ThemeToggle />
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Mobile menu overlay */}
      {isMenuOpen && (
        <div className='mobile-menu-overlay' onClick={closeMenu}></div>
      )}
    </header>
  );
};

export default Header;
